/*eslint no-use-before-define:0 */ //TODO REMOVE THIS
var dd = require("ES/lib/dd");
var _ = require("ES/lib/lodash");
var radio = require("ES/lib/radio");
var esUtils = require("ES/utils/esUtils");
var RadioMixin = require("ES/utils/RadioMixin");
var ErrorAlert = require("ES/widgets/ErrorAlert");
var LoadingWrap = require("ES/widgets/LoadingWrap");
var AuthedUserSession = require("../../../utils/AuthedUserSession");

module.exports = dd.createClass({
  mixins: [RadioMixin],
  getInitialState: function () {
    return {
      sid: -1,
      has_google_connected: null,
      is_reading: false,
      read_error_msg: null,
    };
  },
  componentWillReceiveProps: function (props) {
    this.__loadForSid(props.selected_sid);
  },
  componentDidMount: function () {
    this.__loadForSid(this.props.selected_sid);
  },
  __loadForSid: function (sid) {
    if (sid != this.state.sid) {
      this.setState(
        {
          sid: sid,
          has_google_connected: null,
          is_reading: false,
          read_error_msg: null,
        },
        function () {
          radio("read_Thirdpartyconnection_Google_config").broadcast(sid);
        }
      );
    }
  },
  componentWillMount: function () {
    var self = this;
    self.radio = {
      read_Thirdpartyconnection_Google_config: function (sid) {
        if (self.state.sid == sid) {
          self.setState({
            has_google_connected: null,
            is_reading: true,
            read_error_msg: null,
          });
        }
      },
      read_Thirdpartyconnection_Google_config_succeeded: function (
        sid,
        has_it
      ) {
        if (self.state.sid == sid) {
          self.setState({
            has_google_connected: !!has_it,
            is_reading: false,
            read_error_msg: null,
          });
        }
      },
      read_Thirdpartyconnection_Google_config_failed: function (sid, message) {
        if (self.state.sid == sid) {
          self.setState({
            has_google_connected: null,
            is_reading: false,
            read_error_msg:
              "Failed to read your Google connector settings: " + message,
          });
        }
      },
    };
  },
  render: function () {
    var Displaylists = this.props.Displaylists;
    var speaker = _.find(
      Displaylists && Displaylists.perspeaker,
      function (spkr) {
        return spkr.sid == this.state.sid;
      },
      this
    );

    var connect_url =
      "/balboa3/thirdpartyconnection/configgoogle/" +
      this.state.sid +
      "/start_oauth?" +
      esUtils.phpCompatibleParams(AuthedUserSession.balboa);

    return dd.div(
      null,
      LoadingWrap(
        { is_loading: this.state.is_reading, glass: true },
        dd.h3(
          null,
          "Google Contacts connector for ",
          dd.span({ className: "nametag" }, AuthedUserSession.MY_USERNAME),
          " + ",
          dd.span({ className: "nametag" }, speaker ? speaker.name_full : "")
        ),
        dd.p(
          { className: "text-muted" },
          "NOTE: The settings for this connector is for your eSpeakers account for this speaker specifically.  ",
          "Other users for this speaker account will need to configure this individually with their own Google login."
        ),
        ErrorAlert({ message: this.state.read_error_msg }),
        this.state.has_google_connected === true
          ? dd.div(
              null,
              dd.div(
                { className: "alert alert-success" },
                "You are connected to Google!"
              ),
              dd.a(
                { href: connect_url },
                "Click here to change the Google account to which you are connected."
              ),
              dd.p(
                { className: "small", style: { marginTop: "1rem" } },
                "EventCX's use and transfer to any other app of information received from Google APIs will adhere to Google API Services User Data Policy, including the ",
                dd.a(
                  {
                    href: "https://developers.google.com/terms/api-services-user-data-policy",
                  },
                  "Limited Use requirements"
                ),
                dd.span(null, ".")
              )
            )
          : dd.div(
              null,
              dd.p(
                null,
                "The link below will take you to Google's site, where you can sign in to Google and choose which of your Google accounts you want to link to ",
                "(if you have more than one Google account)."
              ),
              dd.p(
                null,
                "Google will ask if it's OK for eSpeakers to access your contacts, and you should ",
                dd.b(null, "choose ALLOW ACCESS.")
              ),
              dd.a(
                { href: connect_url, className: "btn btn-default" },
                dd.img({
                  src: "img/google_contacts_icon_2022.png",
                  height: 24,
                  width: 24,
                }),
                " Connect your Google Contacts"
              ),
              dd.p(
                { className: "small", style: { marginTop: "1rem" } },
                "EventCX's use and transfer to any other app of information received from Google APIs will adhere to Google API Services User Data Policy, including the ",
                dd.a(
                  {
                    href: "https://developers.google.com/terms/api-services-user-data-policy",
                  },
                  "Limited Use requirements"
                ),
                dd.span(null, ".")
              )
            )
      )
    );
  },
});



// WEBPACK FOOTER //
// ./src/components/account_settings/connect/GoogleContacts.js